<template>
  <div id="general_skaly_list">
    <template>
      <div>
        <v-data-table
          :options.sync="options"
          :server-items-length="totalItems"
          :headers="headers"
          :items="forms"
          :search="search_form"
          :loading="loading"
          :footer-props="{
            'items-per-page-options': [10, 20, 30, 40, 50, 100]
          }"
          :items-per-page="20"
          class="elevation-1"
        >
          <template v-slot:top>
            <!-- <v-subheader>Zoznam Formulárov</v-subheader>
            <v-divider></v-divider> -->

            <v-layout class="pa-3">
              <v-text-field
                v-model="search_form"
                label="Vyhľadať"
              />
              <v-switch
                v-model="my_only"
                class="pl-5"
                label="Iba vlastné"
              />
              <v-switch
                v-model="active_only"
                class="pl-5"
                label="Iba aktívne"
              />
            </v-layout>
          </template>

          <template v-slot:item.action="{ item }">
            <v-icon
              v-if="canEdit(item)"
              small
              class="mr-3"
              @click="editItem(item)"
            >
              mdi-eye
            </v-icon>
            <v-icon
              v-if="canDelete(item)"
              small
              color="red"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>

          <template v-slot:item.closed="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-if="item.closed"
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-close
                </v-icon>
                <v-icon
                  v-else
                  small
                  class="mr-1"
                  v-on="on"
                >
                  mdi-check
                </v-icon>
              </template>
              <span v-if="item.closed">Uzavreté</span>
              <span v-else>Aktívne</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <v-btn
          fab
          bottom
          left
          color="pink"
          dark
          fixed
          @click="dialog = !dialog"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </template>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title>Nový formulár</v-card-title>
        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-autocomplete
                v-model="item_new.prisoner"
                item-text="string_details"
                item-value="id"
                prepend-icon="mdi-email"
                placeholder="Základné číslo"
                label="Základné číslo"
                :items="prisoners"
                auto-select-first
                :search-input.sync="search"
                cache-items
                :loading="loading_prisoners"
                hide-no-data
              />
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="dialog = false"
          >
            Zrušiť
          </v-btn>
          <v-btn
            text
            @click="createItem()"
          >
            Vytvoriť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { APIService } from "@/http/APIService.js";
import auth from "@/api/auth";

const apiService = new APIService();

export default {
  name: "GeneralFormListComponent",

  props: {
    formName: { type: String, required: true },
    getItemsFunction: { type: Function, required: true },
    createItemFunction: { type: Function, required: true },
    deleteItemFunction: { type: Function, required: true },
  },

  data: () => ({
    timeout: null,
    active_only: true,
    my_only: true,
    dialog: false,
    loading: true,
    loading_prisoners: false,
    search_form: "",
    search: null,
    totalItems: 0,
    options: {},

    headers: [
      {
        text: "Interné ID",
        value: "id",
      },
      { text: "Základné číslo", value: "prisoner_full.base_number" },
      { text: "Meno", value: "prisoner_full.name_full" },

      { text: "Ústav", value: "institution_full.name" },
      {
        text: "Vytvoril",
        value: "created_by_full.username",
      },
      { text: "Vytvorený", value: "created_at" },
      { text: "Posledná zmena", value: "updated_at" },
      { text: "Stav", value: "closed" },
      { text: "Akcie", value: "action", sortable: false },
    ],

    forms: [],

    item_new: {
      prisoner: "",
    },

    prisoners: [],
  }),
  computed: mapGetters("auth", ["isAuthenticated", "username"]),

  watch: {
    search(val) {
      val && this.querySelections(val);
    },
    active_only() {
      this.getDataFromApi();
    },
    my_only() {
      this.getDataFromApi();
    },
    multiple_forms() {
      this.getDataFromApi();
    },
    search_form() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.getDataFromApi();
      }, 500);
    },
    options: {
      handler() {
        this.getDataFromApi();
      },
    },
    deep: true,
  },

  created() {
    // this.querySelections("");

    auth.getAccountDetails().then((response) => {
      this.user_pk = response.data.pk;
    });
  },

  methods: {
    canDelete(item) {
      if (item.permissions.delete) return true;

      return false;
    },
    canEdit(item) {
      if (item.permissions.change) return true;
      return false;
    },

    getClosed(item) {
      if (item == true) return "uzavretý";
      else return "otvorený";
    },
    getColor(item) {
      if (item == true) return "white";
      else return "red";
    },

    createItem() {
      this.createItemFunction(this.item_new).then(
        (response) => {
          this.dialog = false;
          this.$router.push({
            name: this.formName,
            params: { id: response.id },
          });
        },
      );
    },

    getForms(sort, search, limit, offset, filter_key, filter_value) {
      this.loading = true;

      this
        .getItemsFunction(
          sort,
          search,
          limit,
          offset,
          filter_key,
          filter_value
        )
        .then((response) => {
          this.forms = response.results;
          this.totalItems = response.count;
          this.loading = false;
        });
    },

    editItem(item) {
      this.$router.push({
        name: this.formName,
        params: { id: item.id },
      });
    },

    async deleteItem(item) {
      confirm("Naozaj chcete zmazať?") &&
        this.deleteItemFunction(item).then(() => {
          const index = this.forms.indexOf(item);
          this.forms.splice(index, 1);
        });
    },

    querySelections(v) {
      this.loading_prisoners = true;

      apiService.searchPrisoners(v).then((response) => {
        this.prisoners = response.results;
        this.loading_prisoners = false;
      });
    },

    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sort = "";
      if (sortBy) {
        if (sortBy.length === 1 && sortDesc.length === 1) {
          sort = sortBy[0].replace(/\./g, "__").replace(/_full/g, "");
          if (!sortDesc[0]) sort = "-" + sort;
        }
      }

      let offset = "";
      if (itemsPerPage > 0) {
        offset = (page - 1) * itemsPerPage;
      }

      var filters = [];

      if (this.active_only) {
        filters.push(["closed", false]);
      }
      if (this.my_only) {
        filters.push([["created_by__username"], this.username]);
      }

      this.getForms(sort, this.search_form, itemsPerPage, offset, filters);
    },
  },
};
</script>